import React, { useState } from 'react';

import {
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
} from './Checkbox.css';

const Checkbox = ({ id, label, name, value, groupName }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();

    setIsChecked(!isChecked);
  };

  return (
    <CheckboxContainer
      onClick={(e) => {handleChange(e)}}
      className={ isChecked ? 'checked' : '' }
      checked={isChecked}
    >
      <CheckboxInput
        type={`checkbox`}
        value={value}
        name={name}
        id={id}
        checked={isChecked}
        data-group-name={groupName}
      />

      <CheckboxLabel for={id}>{label}</CheckboxLabel>
    </CheckboxContainer>
  );
};

export default Checkbox;